import { Paper, SxProps, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Theme } from '@mui/material'
import { ID } from '../../types/models'
import { useLocation, useNavigate } from 'react-router-dom'
import { value } from './util'

export type DataTableColumns<Type> = Record<string, string | ((t: Type) => string | React.ReactElement)>

export interface DataTableProps<Type> {
  data: Type[]
  columns: DataTableColumns<Type>
  link?: string
  sx?: SxProps<Theme>
  dataCy?: string
}

export function DataTable<Type extends { id?: ID }>(props: DataTableProps<Type>): React.ReactElement {
  const { data, columns, link, sx, dataCy } = props
  const navigate = useNavigate()
  const location = useLocation()

  return (
    <TableContainer data-cy={dataCy} component={Paper} sx={sx}>
      <Table size="small">
        <TableHead>
          <TableRow>
            {
              Object.keys(columns).map((col, idx) => (
                <TableCell sx={{ color: '#fff' }} key={idx}>{col}</TableCell>
              ))
            }
          </TableRow>
        </TableHead>
        <TableBody>
          {
            data.map((line, idx) => (
              <TableRow
                key={idx}
                hover={!!link}
                onClick={() => !!link && navigate(`${link.replace(':id', `${line.id}`)}`, { state: { prev: location.pathname.replace(/^\/app/, '') } })}
              >
                {
                  Object.keys(columns).map((col, idx) => {
                    const column = columns[col]

                    return <TableCell sx={
                      {
                        color: '#fff',
                        cursor: link ? 'pointer' : 'initial',
                        '&:hover': { color: link ? '#ccc' : '#fff' }
                      }} key={idx}>
                        {value(column, line)}
                      </TableCell>
                  })
                }
              </TableRow>
            ))
          }
        </TableBody>
      </Table>
    </TableContainer>
  )
}
